import React from 'react';
import { defineMessages, injectIntl } from '@kyruus/intl';
import { arrayOf, bool, element, func, node, number, string } from 'prop-types';

import Modal from '@kyruus/modal';

import ModalBody from './modal-body';

const messages = defineMessages({
  closeLabel: {
    id: 'aria.label.close_button',
    description: 'Aria label for close button within modal',
    defaultMessage: 'Close'
  }
});

class CtaModal extends React.Component {
  constructor() {
    super();

    this.shouldRenderModalFullScreenListener =
      this.shouldRenderModalFullScreenListener.bind(this);

    this.state = { shouldRenderModalFullscreen: false };
  }

  componentDidMount() {
    if (window && window.matchMedia) {
      this.modalFullScreenMq = window.matchMedia('(max-width: 420px)');

      this.setState({
        shouldRenderModalFullscreen: this.modalFullScreenMq.matches
      });

      this.modalFullScreenMq.addListener(
        this.shouldRenderModalFullScreenListener
      );
    }
  }

  componentWillUnmount() {
    if (this.modalFullScreenMq) {
      this.modalFullScreenMq.removeListener(
        this.shouldRenderModalFullScreenListener
      );
    }
  }

  shouldRenderModalFullScreenListener({ matches }) {
    this.setState({
      shouldRenderModalFullscreen: matches
    });
  }

  render() {
    const {
      ariaLabelledBy,
      id,
      onClose,
      open,
      panelCount,
      panels,
      role,
      title,
      intl
    } = this.props;
    const closeAriaLabel = intl.formatMessage(messages.closeLabel);
    return (
      <Modal
        id={id}
        role={role}
        headerTestId="ctaModalHeader"
        closeBtnTestId="ctaModalCloseBtn"
        closeAriaLabel={closeAriaLabel}
        aria-labelledby={ariaLabelledBy}
        // modal renders outside the pmc-app container
        // so we need to add this class to ensure our styles can target the modal contents
        className="kyruus-custom"
        title={title}
        body={<ModalBody panels={panels} />}
        open={open}
        onClose={onClose}
        maxWidth={
          {
            1: 'xs',
            2: 'md',
            3: 'lg',
            4: 'xl'
          }[panelCount]
        }
        topAligned={true}
        fullScreen={this.state.shouldRenderModalFullscreen}
      />
    );
  }
}

CtaModal.propTypes = {
  ariaLabelledBy: string,
  id: string.isRequired,
  onClose: func,
  open: bool,
  panelCount: number,
  panels: arrayOf(element).isRequired,
  role: string,
  title: node.isRequired
};

export default injectIntl(CtaModal);
